import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../../utils';
import type { MapperItemConfig } from './types';

export const getLandingPagePath = ({ slug = '' }: MapperItemConfig) => {
    const params = { page_name: slug };

    return pathfinder(PATHFINDER.LANDING_PAGE, params);
};
